document.addEventListener('DOMContentLoaded', function() {
  // Countdown Timer
  function initializeCountdown() {
    const countdownElements = document.querySelectorAll('.fundraiser-countdown');
    
    countdownElements.forEach(element => {
      const endDate = new Date(element.dataset.endDate).getTime();
      
      function updateCountdown() {
        const now = new Date().getTime();
        const distance = endDate - now;
        
        if (distance < 0) {
          element.innerHTML = "FUNDRAISER ENDED";
          clearInterval(timer);
          return;
        }
        
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
        element.querySelector('.countdown-hours').textContent = hours.toString().padStart(2, '0');
        element.querySelector('.countdown-minutes').textContent = minutes.toString().padStart(2, '0');
        element.querySelector('.countdown-seconds').textContent = seconds.toString().padStart(2, '0');
      }
      
      const timer = setInterval(updateCountdown, 1000);
      updateCountdown();
    });
  }

  // Real-time progress updates
  function initializeProgressUpdates() {
    const progressElements = document.querySelectorAll('.fundraiser-progress');
    
    if (progressElements.length === 0) return;
    
    const productId = progressElements[0].dataset.productId;
    
    function fetchProgress() {
      fetch(`/apps/fundraiser-progress?product_id=${productId}`)
        .then(response => response.json())
        .then(data => {
          progressElements.forEach(element => {
            element.querySelector('.supported-count').textContent = `${data.supported_count} SUPPORTED`;
            element.querySelector('.raised-amount').textContent = `$${data.raised_amount} RAISED OF $${data.goal_amount} GOAL`;
            element.querySelector('.percent-funded').textContent = `${data.percent_funded}% funded`;
            
            const progressFill = element.querySelector('.progress-fill');
            progressFill.style.width = `${data.percent_funded > 100 ? 100 : data.percent_funded}%`;
          });
        })
        .catch(error => console.error('Error fetching progress:', error));
    }
    
    // Fetch immediately and then every 30 seconds
    fetchProgress();
    setInterval(fetchProgress, 30000);
  }

  initializeCountdown();
  initializeProgressUpdates();
});